import { Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { TranslationService } from 'src/app/shared/translations/services/translation.service';
import { ActionDetails, ActionType, DispositionType, getActionType, getDispositionType } from '../../models/SpecLine';
import { Subject, takeUntil } from 'rxjs';
import { TranslationState } from '../../../../shared/state/TranslationState';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-ntr-age',
  templateUrl: './ntr-age.component.html',
  styleUrls: ['./ntr-age.component.scss'],
  standalone: false
})
export class NtrAgeComponent implements OnInit, OnChanges {
  @Input() ntr: ActionDetails;
  @Input() age: ActionDetails;
  @Input() editMode: boolean;
  public translationService = inject(TranslationService);
  public specificationFormGroup = inject(FormGroupDirective);
  public store = inject(Store);

  private readonly ngUnsubscribe = new Subject<void>();
  isDefault: boolean;
  ntrFormGroup: FormGroup;
  ageFormGroup: FormGroup;

  constructor() {}

  ngOnInit(): void {
    this.ntrFormGroup = this.specificationFormGroup.control.get('ntr') as FormGroup;
    this.ageFormGroup = this.specificationFormGroup.control.get('age') as FormGroup;
    this.prepopulateForm();
    this.store
      .select(TranslationState.currentLanguage)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.prepopulateForm();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('editMode' in changes) {
      this.prepopulateForm();
    }
    if (this.specificationFormGroup && 'ntr' in changes && 'age' in changes) {
      this.ntrFormGroup = this.specificationFormGroup.control.get('ntr') as FormGroup;
      this.ageFormGroup = this.specificationFormGroup.control.get('age') as FormGroup;
      this.isDefault = this.specificationFormGroup.control.get('isDefault').value;
      this.prepopulateForm();
    }
  }

  prepopulateForm(): void {
    this.ntrFormGroup.patchValue({
      limit: this.ntr.limit,
      action: this.translationService.translate(getActionType(this.ntr.action)),
      disposition: this.translationService.translate(getDispositionType(this.ntr.disposition)),
      disposalCode: this.ntr.disposalCode,
      application: this.ntr.application,
      axle: this.ntr.axle,
      treads: this.ntr.treads
    });

    this.ageFormGroup.patchValue({
      limit: this.age.limit,
      action: this.translationService.translate(getActionType(this.age.action)),
      disposition: this.translationService.translate(getDispositionType(this.age.disposition)),
      disposalCode: this.age.disposalCode,
      application: this.age.application,
      axle: this.age.axle,
      treads: this.age.treads
    });
  }

  protected readonly ActionType = ActionType;
  protected readonly DispositionType = DispositionType;
}
